import { Col, Row } from "antd";
import Logo from "assets/users/svg/bg_header_projects.svg";
import { ButtonGradient, ContainerFluidCustom } from "components/base";
import styled from "styled-components";

export const BackgroundContainer = styled.div`
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%),
    url(${Logo});
  min-height: 150px;
  position: relative;
  font-family: "Rubik";
  font-style: normal;
  margin-bottom: 20px;
  background-repeat: repeat;
  background-size: cover;
  border-radius: 24px;

  /* Responsive Boxed Layout - Localized fix for Projects Page */
  margin: 0px 16px 50px 16px;
  width: auto;

  @media (min-width: 1200px) {
    margin: 0px 136px 50px 136px;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    margin: 0px 24px 50px 24px;
    border-radius: 24px;
  }

  /* Key: This ensures content doesn't overflow or break homepage */
  max-width: 100vw;

  @media (max-width: 768px) {
    height: auto;
    padding-bottom: 0;
    min-height: auto;
    border-radius: 0;
    margin: 0 0 20px 0; /* Full bleed on mobile */
  }
`;

export const SubHeaderProjectsImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 24px;

  @media (max-width: 768px) {
    position: relative;
    height: 200px;
    border-radius: 0;
  }
`;

export const SubHeader = styled(Row)`
  position: relative;
  margin-left: 0 !important;
  margin-right: 0 !important;
`;

export const ContainerInfoProject = styled.div`
  top: 34%;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0 16px;
  border-radius: 24px;

  @media (min-width: 1200px) {
    padding: 0;
  }

  @media (max-width: 768px) {
    position: relative;
    top: unset;
    margin: 0;
    margin-top: 10px;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
  }
`;

export const Avatar = styled.img`
  width: 68px;
  height: 68px;
  background: #e6e6e6;
  border-radius: 50%;
  margin: 16px 16px;
  @media (max-width: 768px) {
    margin: 0;
    margin-bottom: 12px;
    margin-top: -34px; /* Pull avatar up to overlap banner slightly */
    border: 3px solid white; /* Add border to separate from banner */
  }
`;

export const InfoProject = styled(Col)`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const InfoNameProject = styled.div`
  height: 60%;
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
    height: auto;
    margin-top: 10px;
  }
`;

export const NameProject = styled.div`
  display: flex;
`;

export const Name = styled.p`
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: rgba(255, 255, 255, 0.8);
  margin: unset;
  @media (max-width: 768px) {
    color: #080a25;
  }
`;

export const Role = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: rgba(255, 255, 255, 0.6);
  @media (max-width: 768px) {
    color: rgba(8, 10, 37, 0.6);
  }
`;

export const TagLabel = styled.p`
  color: #ffffff;
  background: linear-gradient(93.82deg, #ffce07 -1.69%, #f57f20 104.17%);
  border-radius: 4px;
  padding: 4px;
  margin-left: 12px;
`;

export const CommunityProject = styled(Col)`
  display: flex;
  justify-content: end;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: flex-start;
    margin-top: 10px;
    padding-left: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const TotalMember = styled.p`
  margin: 20px 24px;
  color: rgba(255, 255, 255, 0.8);
  @media (max-width: 768px) {
    margin: 0;
    color: #333; /* Darker text since it might be on white background now */
  }
`;

export const ButtonJoinCommunity = styled(ButtonGradient)`
  border: none;
  white-space: nowrap;

  @media (max-width: 768px) {
    width: auto;
    margin-right: 0;
    margin-top: 10px;
    font-size: 14px;
  }
`;
